import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import user2 from "../../images/ic_no_person_photo.svg";
import { FaRegEdit } from "react-icons/fa";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import { toast } from "react-toastify";
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { FaSearch } from "react-icons/fa";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import { FiCheck, FiX, FiRefreshCw } from "react-icons/fi";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { BsGraphUpArrow } from "react-icons/bs";

const EndOfServiceApproval = () => {
  const [data, setData] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedgrade, setSelectedGrade] = useState("");
  const [selectedJob, setSelectedJobTitle] = useState("");
  const [loader, setLoader] = useState(true);
  const [resetalldata, setResetallData] = useState(false);
  const [Division, setDivision] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [grade, setGrade] = useState(null);
  const [jobtitle, setJobTitle] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [dateOfJoin, setDateOfJoin] = useState(null);
  const [dateOfApplication, setDateOfApplication] = useState(null);
  const [endOfService, setEndOfService] = useState(null);
  const [statusDataEOS, setStatusDataEOS] = useState(null);
  const [isActive, setIsActive] = useState("REQUESTED");
  const [daysWorked, setDaysWorked] = useState(0);
  const [divisionMUI, setDivisionMUI] = useState("");
  const [searchdata, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState(null);

  const [debouncedSearch, setDebouncedSearch] = useState(searchdata);
  const [jobMUI, setJobMUI] = useState("");
  const [gradeMUI, setGradeMUI] = useState("");
  const [reasonNotes, setReasonNotes] = useState("");
  const [seperationMethod, setSeperationMethod] = useState("RESIGNATION");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const [base_url] = useState(base_url_from_axios_config);

  //     const lastIndex = currentPage * recordsPerPage;
  //   const firstIndex = lastIndex - recordsPerPage;
  //   const records = data?.slice(firstIndex, lastIndex);

  const formatDateWithExpiry = (date) => {
    if (!date) return <span>-</span>;

    const parsed = new Date(date);
    if (isNaN(parsed)) return <span>-</span>;

    const isExpired = parsed < new Date();

    return (
      <span className={isExpired ? "text-red-600 font-medium" : ""}>
        {parsed.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    );
  };

  const getData = async (activeEOS) => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${base_url}/api/cpayscount/${companyCode}/EOSFORAPPROVAL/-/${activeEOS}`,
      );

      if (response?.data) {
        setData(response.data);
        setFilteredData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching employee data");
    } finally {
      setLoader(false);
      if (resetalldata) setResetallData(false);
    }
  };

  useEffect(() => {
    getData("REQUESTED");
    getStatusData();
  }, []);

  // useEffect(() => {
  //   if (base_url && companyCode && jobtitle && grade && Division) {
  //     getData();
  //   }
  // }, [
  //   base_url,
  //   companyCode,
  //   searchParams,
  //   searchdata,
  //   selectedJob,
  //   selectedgrade,
  //   selectedDivision,
  //   resetalldata,
  //   jobtitle,
  //   grade,
  //   Division,
  // ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchdata);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchdata]);

  useEffect(() => {
    if (dateOfJoin && endOfService) {
      const days = dayjs(endOfService).diff(dayjs(dateOfJoin), "day");
      setDaysWorked(days);
    }
  }, [dateOfJoin, endOfService]);

  // Fetch profile picture
  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user2;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  const onRecordSelect = (records) => {
    setSelectedEmployee(records);
    getStatusData(records.EmpId);
  };

  const onProceedEOSApproval = async (statusFromButton) => {
    const today = new Date().toISOString().split("T")[0];

    const storedLoginUser =
      JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
    let user = null;

    if (storedLoginUser) {
      user = storedLoginUser[0].user.trim();
    }

    const payload = [
      {
        CmpCode: companyCode,
        mode: "EOSAPPROVAL",
        DocNo: selectedEmployee.serialcode,
        DeptNO: storedLoginUser[0].DEPTNO,
        Status: statusFromButton,
        Comments: selectedEmployee.Notes,
        UserID: storedLoginUser[0].EMPID,
        created_on: today,
      },
    ];
    try {
      const response = await axios.post(
        `${base_url}/api/ProposalStatus`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      const data = response.data;
      console.log("Saved EOS Approval:", data);
      getData();
      setSnackbar({
        open: true,
        message: `EOS  ${statusFromButton} SUCCESSFULLY`,
        severity: "success",
      });
    } catch (error) {
      console.error("Error while saving EOS Approval:", error);
    }
  };

  const navigate = useNavigate();
  const onGratuityMonitor = (employee) => {
    navigate("/admin/gratuityMonitor", { state: { item: employee } });
  };

  const getStatusData = async (empID) => {
    try {
      const response = await axios.get(
        `${base_url}/api/cpayscount/${companyCode}/EOSAPPSTATUS/${empID}/-`,
      );
      console.error("Success fetching EOS Status:", response);
      const data = response.data;
      setStatusDataEOS(data);
    } catch (error) {
      console.error("Error while fetching EOS Status:", error);
    }
  };

  const isFormValid = selectedEmployee;

  useEffect(() => {
    if (searchdata) {
      const searchResult = data.filter(
        (item) =>
          item.EmpId?.toString()
            .toLowerCase()
            .includes(searchdata.toLowerCase()) ||
          item.Name?.toLowerCase().includes(searchdata.toLowerCase()),
      );

      setFilteredData(searchResult);
    } else {
      setFilteredData(data);
    }
  }, [searchdata, data]);

  return (
    <div className="w-full min-h-screen">
      {/* Header */}
      <div className="flex items-center justify-between text-white px-4 py-3 rounded-t-lg">
        <div className="flex justify-left items-center mb-4 ">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              END OF SERVICE APPROVAL
            </span>
          </h6>
        </div>
      </div>

      {selectedEmployee && (
        <>
          <div className="flex  justify-between items-center bg-white p-2 mb-4 border rounded-md">
            <div className="flex gap-4 items-center">
              <img
                src={
                  selectedEmployee?.imagepath
                    ? fetchProfilePic(selectedEmployee.imagepath)
                    : user2
                }
                alt="employee"
                className="w-20 h-20 object-cover "
              />
              {/* <img
            className="w-7 h-7 rounded-full object-cover"
            src={d.imagepath ? fetchProfilePic(d.imagepath) : user2}
            alt=""
          /> */}
              <div className="text-sm space-y-1">
                <div>
                  <span className="text-gray-600">Employee ID</span>
                  {" : "}
                  <span className="font-semibold">
                    {selectedEmployee?.EmpId || "-"}
                  </span>
                </div>

                <div>
                  <span className="text-gray-600">Name</span>
                  {" : "}
                  <span className="font-semibold">
                    {selectedEmployee?.Name || "-"}
                  </span>
                </div>

                {/* <div>
              <span className="text-gray-600">Department</span>{" "}
              <span>Calender days</span>
            </div> */}

                <div>
                  <span className="text-gray-600">Job Title</span>{" "}
                  <span className="font-semibold">
                    {" "}
                    {selectedEmployee?.JobTitle || "-"}
                  </span>
                </div>
                <div>
                  <span className="text-gray-600">Divsion</span>
                  {" : "}
                  <span className="font-semibold">
                    {" "}
                    {selectedEmployee?.Division || "-"}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                Application Date
              </label>

              <div className="relative">
                <input
                  // type="date"
                  value={selectedEmployee?.ApplicationDate.split("T")[0]}
                  // value={selectedEmployee.ApplicationDate}
                  // value={dateOfApplication}
                  // onChange={(e) => setDateOfApplication(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm 
      focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB]
      transition-all duration-200"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                Date of Join
              </label>

              <div className="relative">
                <input
                  // type="date"
                  value={selectedEmployee?.JOIN_DT.split("T")[0]}
                  // onChange={(e) => setDateOfJoin(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm 
      focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB]
      transition-all duration-200"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                End of Service Date
              </label>

              <div className="relative">
                <input
                  // type="date"
                  onChange={(e) => setEndOfService(e.target.value)}
                  // value={endOfService}
                  value={selectedEmployee?.END_DATE.split("T")[0]}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm 
      focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB]
      transition-all duration-200"
                />
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                Seperation Method
              </label>
              <span
                className="w-full rounded-lg px-3 py-2 text-sm font-semibold
      focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB]
      transition-all duration-200"
              >
                {selectedEmployee?.EOS_Type || "-"}
              </span>
              {/* <select
            onChange={setSeperationMethod}
            className="border w-full px-2 py-1"
          >
            <option value="RESIGNATION">RESIGNATION</option>
            <option value="TERMINATION">TERMINATION</option>
          </select> */}
            </div>

            <button
              onClick={() => onGratuityMonitor(selectedEmployee)}
              disabled={!isFormValid}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium 
   text-white rounded-md transition  ${!isFormValid ? "bg-gray-300 hover:bg-gray-400 cursor-not-allowed" : "cursor-pointer bg-purple-500 hover:bg-purple-700 "}`}
            >
              <BsGraphUpArrow className="text-sm" />
              Gratuity Monitor
            </button>

            <div className="flex gap-2">
              <Tooltip
                title={!isFormValid ? "Please select employee!" : ""}
                arrow
              >
                {isActive === "REQUESTED" ? (
                  <div className="flex justify-center items-center gap-4">
                    <button
                      onClick={() => onProceedEOSApproval("APPROVED")}
                      disabled={!isFormValid}
                      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium 
                  text-white rounded-md transition ${!isFormValid ? "bg-gray-300 hover:bg-gray-400 cursor-not-allowed" : "cursor-pointer bg-green-500 hover:bg-green-600"}`}
                    >
                      <FiCheck className="text-sm" />
                      Approve
                    </button>

                    <button
                      onClick={() => onProceedEOSApproval("REJECTED")}
                      disabled={!isFormValid}
                      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium 
                    text-white rounded-md transition  ${!isFormValid ? "bg-gray-300 hover:bg-gray-400 cursor-not-allowed" : "cursor-pointer bg-red-500 hover:bg-red-600"}`}
                    >
                      <FiX className="text-sm" />
                      Reject
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => onProceedEOSApproval("REQUESTED")}
                    disabled={!isFormValid}
                    className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium 
   text-white rounded-md transition  ${!isFormValid ? "bg-gray-300 hover:bg-gray-400 cursor-not-allowed" : "cursor-pointer bg-[#02C1FE] hover:bg-[#02a8dc] "}`}
                  >
                    <FiRefreshCw className="text-sm" />
                    Re-evaluate
                  </button>
                )}
              </Tooltip>
            </div>
          </div>
        </>
      )}

      <div>
        <div className="flex w-fit bg-white p-1 rounded-full border border-1 mb-4">
          {/* Requested */}
          <button
            type="button"
            onClick={() => {
              setIsActive("REQUESTED");
              getData("REQUESTED");
              setSelectedEmployee(null);
              setSearchData("")
            }}
            className={`px-5 py-2 text-sm rounded-full transition-all duration-300 font-semibold
      ${
        isActive === "REQUESTED"
          ? "bg-[#2663EB] text-white shadow-md"
          : "text-gray-600 hover:text-[#2663EB]"
      }`}
          >
            Requested
          </button>

          <button
            type="button"
            onClick={() => {
              setIsActive("APPROVED");
              getData("APPROVED");
              setSelectedEmployee(null);
              setSearchData("")
            }}
            className={`px-5 py-2 text-sm rounded-full transition-all duration-300 font-semibold
      ${
        isActive === "APPROVED"
          ? "bg-green-500 text-white shadow-md"
          : "text-gray-600 hover:text-green-600"
      }`}
          >
            Approved
          </button>

          {/* Rejected */}
          <button
            type="button"
            onClick={() => {
              setIsActive("REJECTED");
              getData("REJECTED");
              setSelectedEmployee(null);
              setSearchData("")
            }}
            className={`px-5 py-2 text-sm rounded-full transition-all duration-300 font-semibold
      ${
        isActive === "REJECTED"
          ? "bg-red-500 text-white shadow-md"
          : "text-gray-600 hover:text-red-500"
      }`}
          >
            Rejected
          </button>
        </div>
      </div>

      {/* Main Layout */}
      <div className="flex gap-4  ">
        {/* Employee List */}
        <div className=" border p-3 rounded-md w-full  h-[50%] bg-white">
          <div className=" flex  items-center justify-left gap-24 mb-4">
            <div className=" flex flex-col items-left justify-left">
              <h3 className="text-[#2663EB] font-semibold mb-2">
                Application for{" "}
                {isActive === "REQUESTED"
                  ? "Requested"
                  : isActive === "APPROVED"
                    ? "Approved"
                    : "Rejected"}{" "}
              </h3>
              <h6 className="text-gray-400 text-xs font-semibold mb-2">
                Select the employee to proceed
              </h6>
            </div>
            <div className=" w-[400px] bg-white flex items-center gap-2 p-2  border border-gray-700 rounded-md transition-all duration-200  focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search By ID or Name..."
                value={searchdata}
                onChange={(e) => setSearchData(e.target.value)}
                className="w-full bg-white outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {searchdata && (
                <button
                  onClick={() => setSearchData("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div>

            {/* Filters */}
            {/* <div className="flex gap-2 mb-2"> */}
            {/* <select className="border px-2 py-1 text-sm">
              <option>Division</option>
            </select>

            <select className="border px-2 py-1 text-sm">
              <option>Dept</option>
            </select> */}
            {/* </div> */}
          </div>
          {/* [
  {
    "EOS_Type": "RESIGNATION",
    "ApplicationDate": "2026-03-13T00:00:00",
    "JOIN_DT": "2026-03-03T00:00:00",
    "END_DATE": "2026-03-06T00:00:00",
    "Total_Days": 5,
    "Notes": "approved with conditions",
    "ApprovalStatus": "APPROVED",
    "EmpId": "908",
    "Name": "Abdul  Raheem",
    "JobTitle": "",
    "Department": "",
    "Division": "",
    "Grade": "",
    "Nationality": "",
    "serialcode": 2
  }
] */}
          {/* Employee Table */}
          <div className="overflow-auto  max-h-[30vh]  border scrollbar-none bg-white">
            <table className="min-w-full border-separate border-spacing-0">
              <thead className="sticky top-0 z-10">
                <tr className="bg-[#2663EB] text-white text-sm">
                  <th className="px-3 py-2 font-medium text-left">Sl Code</th>
                  <th className="px-3 py-2 font-medium text-left">EmpId</th>
                  <th className="px-3 py-2 font-medium text-left">Name</th>
                  <th className="px-3 py-2 font-medium text-left">EOS Type</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Application Date
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Join Date</th>
                  <th className="px-3 py-2 font-medium text-left">End Date</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Total Days
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Notes</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Approval Status
                  </th>

                  <th className="px-3 py-2 font-medium text-left">Job Title</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Department
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Division</th>
                  <th className="px-3 py-2 font-medium text-left">Grade</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Nationality
                  </th>
                </tr>
              </thead>

              <tbody className="text-sm text-gray-700">
                {filteredData?.map((d, i) => (
                  <tr
                    key={i}
                    className={`border  transition-colors duration-150 ${selectedEmployee == d ? "bg-blue-50 " : "hover:bg-gray-50"}`}
                    onClick={() => onRecordSelect(d)}
                  >
                    <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                      {d.serialcode}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.EmpId}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Name}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border ">
                      {d?.EOS_Type}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(d?.ApplicationDate).format("DD-MMM-YYYY")}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(d?.JOIN_DT).format("DD-MMM-YYYY")}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap border">
                      <span>{dayjs(d?.END_DATE).format("DD-MMM-YYYY")}</span>
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Total_Days}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Notes}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.ApprovalStatus}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.JobTitle}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Department}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Division}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Grade}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Nationality}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Employee Info */}
      {selectedEmployee && (
        <div className="flex justify-between items-start  rounded-md mt-4 bg-white border ">
          <div className="h-[200px] overflow-auto scrollbar-none w-full  ml-4">
            {/* <div className=" border p-3 rounded-md w-full  h-[50%] "> */}
            {/* <div className=" flex  items-center justify-between mb-2"> */}
            <h3 className="text-[#2663EB] font-semibold mb-2 pt-3 pb-2">
              Application History of Employee
            </h3>
            <table className="min-w-full  border-separate border-spacing-0">
              <thead className="sticky top-0 z-10">
                <tr className="bg-[#2663EB] text-white text-sm">
                  <th className="px-3 py-2 font-medium text-left">Sl</th>
                  <th className="px-3 py-2 font-medium text-left">EOS Type</th>
                  <th className="px-3 py-2 font-medium text-left">Join Date</th>
                  <th className="px-3 py-2 font-medium text-left">End Date</th>
                  <th className="px-3 py-2 font-medium text-left">
                    ُTotal Days
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Status</th>
                </tr>
              </thead>
              <tbody className="text-sm text-gray-700">
                {statusDataEOS?.map((item, i) => (
                  <tr
                    key={i}
                    className={`border  transition-colors duration-150 hover:bg-gray-50`}
                  >
                    <td className="px-3 py-2  border border-gray-100">
                      {item.serialcode}
                    </td>
                    <td className="px-3 py-2  border ">{item?.EOS_Type}</td>
                    <td className="px-3 py-2  border">
                      {dayjs(item["JOIN-DT"]).format("DD-MMM-YYYY")}
                    </td>
                    <td className="px-3 py-2  border">
                      {dayjs(item["END-DATE"]).format("DD-MMM-YYYY")}
                    </td>
                    <td className="px-3 py-2  border">{item?.TOTAL_DAYS}</td>
                    <td className="px-3 py-2  border">{item?.Status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
    // </div>
    // </div>
  );
};

export default EndOfServiceApproval;
